import { PropsWithChildren, ReactNode } from "react";

import { cn } from "@bentolabs/kit/utils";

import { Dialog } from "shared/ui/dialog";

import { Header } from "./header";

type Props = {
  className?: string;
  isOpen?: boolean;
  onOpenChange: (isOpen: boolean) => void;
  img: ReactNode;
  title: string;
};

export const DetailsDialog = (props: PropsWithChildren<Props>) => {
  const { children, className, img, title, isOpen, onOpenChange } = props;
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className={cn("w-auto md:max-w-max", className)}>
        <Dialog.Body>
          <Header img={img} title={title} />
          {children}
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};
